var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camera",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.823,
    height: 13.341,
    viewBox: "0 0 14.823 13.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.372,
    cy: 2.372,
    r: 2.372,
    transform: "translate(5.04 5.04)",
    fill: "#66939e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M7.188,2,5.832,3.482H3.482A1.487,1.487,0,0,0,2,4.965v8.894a1.487,1.487,0,0,0,1.482,1.482H15.341a1.487,1.487,0,0,0,1.482-1.482V4.965a1.487,1.487,0,0,0-1.482-1.482H12.991L11.635,2ZM9.411,13.117a3.706,3.706,0,1,1,3.706-3.706A3.707,3.707,0,0,1,9.411,13.117Z",
    transform: "translate(-2 -2)",
    fill: "#66939e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.5b0f66b02566dc88cec414338526c5f5.svg";
export { ForwardRef as ReactComponent };